import React, { useState } from 'react';
import './MiniQuizModal.css';
import { MiniQuizQuestion } from '../services/api';

interface MiniQuizModalProps {
  isOpen: boolean;
  onClose: () => void;
  question: MiniQuizQuestion;
  onAnswer: (questionId: string, answer: boolean) => Promise<void>;
}

const MiniQuizModal: React.FC<MiniQuizModalProps> = ({
  isOpen,
  onClose,
  question,
  onAnswer
}) => {
  const [selectedAnswer, setSelectedAnswer] = useState<boolean | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleSubmit = async () => {
    if (selectedAnswer === null || isSubmitting) return;

    setIsSubmitting(true);
    try {
      await onAnswer(question.id, selectedAnswer);
      onClose();
    } catch (error) {
      console.error('Error submitting answer:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (!isSubmitting) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="mini-quiz-modal-overlay" onClick={handleOverlayClick}>
      <div className="mini-quiz-modal-container" onClick={(e) => e.stopPropagation()}>
        <button className="mini-quiz-modal-close" onClick={handleClose} disabled={isSubmitting}>
          ×
        </button>
        
        <div className="mini-quiz-modal-content">
          <h2 className="mini-quiz-modal-title">Câu hỏi thưởng</h2>      
          <p className="mini-quiz-question">{question.question}</p>
          
          <div className="mini-quiz-answers">
            <button
              className={`mini-quiz-answer ${selectedAnswer === true ? 'selected' : ''}`}
              onClick={() => setSelectedAnswer(true)}
              disabled={isSubmitting}
            >
              Đúng
            </button>
            <button
              className={`mini-quiz-answer ${selectedAnswer === false ? 'selected' : ''}`}
              onClick={() => setSelectedAnswer(false)}
              disabled={isSubmitting}
            >
              Sai
            </button>
          </div>
          
          <button
            className={`mini-quiz-submit ${selectedAnswer !== null ? 'enabled' : ''}`}
            onClick={handleSubmit}
            disabled={selectedAnswer === null || isSubmitting}
          >
            {isSubmitting ? 'Đang gửi...' : 'Trả lời'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MiniQuizModal;
